<template>
    <div>
        <b-tab :title="$t('message.currentTreatments')" :active="pathHas('traitement')">
            <b-link class="ml-4" :to="{ name: 'add-treatments', params: { file: this.file_id } }" variant="primary" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole || hasAssistante">
                <i class="fas fa-plus-circle edit-icon"></i> {{ $t('message.currentTreatments') }}
            </b-link>

            <b-card-body>
                <vue-good-table id="traitement" :columns="traitementsColumns" :rows="traitementsRows" :search-options="enabled" :pagination-options="paginationOptions" @on-row-click="onTraitementRowClick" />
            </b-card-body>
        </b-tab>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import moment from "moment";
export default {
    name: "Traitement",
    computed: {
         ...mapGetters(["file"]),

        mMedicalFile: function () {
            return _.isUndefined(this.file) ? [] : this.file;
        },
        mTraitements: function () {
            return (typeof this.mMedicalFile.traitements == "object" ? this.mMedicalFile.traitements : []);
        },
        traitementsRows: function () {
            let tArray = [];

            _.forEach(this.mTraitements, function (traitement) {
                // tArray.push({date:traitement.created_at,description: traitement.description,slug:traitement.slug})
                tArray.push({
                    description: traitement.description,
                    slug: traitement.slug,
                    created_at: traitement.created_at,
                })
            });

            return tArray;
        },
    },
    props: ['hasAdminRole', 'hasMedecinControleRole', 'hasAssistante', 'hasPraticienRole', 'file_id'],
    data() {
        return {
            traitementsColumns: [
                {
                    label: 'Date',
                    field: 'created_at',
                },
                {
                    label: 'Description',
                    field: 'description',
                }
            ],
            paginationOptions: {
                enabled: true,
                mode: 'records',
                perPageDropdown: [3, 6, 10]
            },

            enabled: {
                enabled: true
            },

            sort: {
                enabled: true,
                initialSortBy: {
                    field: 'date',
                    type: 'desc'
                }
            },
            
        }
    },
    validations() {
        return {
            form: {
                responsable:{},
            }
        }
	},
    methods: {
        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },
        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },  
        onTraitementRowClick(params) {
            this.$router.push({
                name: 'treatment',
                params: {
                    treatment: params.row.slug
                }
            });
        },
        pathHas(element) {
        let result = (this.$route.fullPath).includes(element);
            if (result) {
                if ($('#' + element).length) {
                    document.getElementById(element).scrollIntoView(top);
                }
            }

            return result;
        },
        notEmpty(item) {
            return item.length > 0;
        },
    },
    mounted() {
        
    }
}
</script>
<style lang="">
    
</style>